import { render, staticRenderFns } from "./MitAdminGenerateResetLinkPage.vue?vue&type=template&id=52b24300&scoped=true"
import script from "./MitAdminGenerateResetLinkPage.vue?vue&type=script&lang=js"
export * from "./MitAdminGenerateResetLinkPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminGenerateResetLinkPage.vue?vue&type=style&index=0&id=52b24300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b24300",
  null
  
)

export default component.exports